module.exports = __webpack_public_path__ + "static/media/logo.683434fb.png";